import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { startSync, clearLocalSession } from "@/lib/offline/sync";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      if (e.response?.status === 401) {
        try {
          await api.post("/auth/refresh");
          const { data } = await api.get("/auth/me");
          setUser(data);
          return;
        } catch (err) {
          setUser(false);
          return;
        }
      }
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
    const onExpired = () => setUser(false);
    window.addEventListener("auth:expired", onExpired);
    return () => window.removeEventListener("auth:expired", onExpired);
  }, [loadMe]);

  useEffect(() => {
    if (user) startSync();
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    await clearLocalSession().catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, register, logout, reload: loadMe }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
export const isSupervisor = (u) => u && ["controleur", "superviseur", "admin"].includes(u.role);
export const isReadOnly = (u) => u?.role === "controleur";
